// extracted by mini-css-extract-plugin
export default {"OngoingView":"OngoingLoanView_OngoingView","orderSection":"OngoingLoanView_orderSection","repaymentWrapper":"OngoingLoanView_repaymentWrapper"};